import { useEffect, useReducer } from 'react'
import { history, useTypedSelector } from '../../redux/store'
import { countToStr, isResponseCodeSuccess } from '../../tools/util'
import {
  OrderInvoicingParams,
  GET_ORDER_INVOICING_PAGE,
  POST_DOWNLOAD_INVOICE_ZIP,
  GET_INVOICE_COUNT,
} from '../../api/orderManage'
import { useSkipInitEffect } from '../../tools/utilHooks'
import { setModuleDataAction } from '../../modules/pagecache'
import { useDispatch } from 'react-redux'
import { SUPROUTE } from '../../route'
import reducer, {
  initialState,
  invoiceTabKey,
  reloadStateAction,
  setCheckedRadioKeyAction,
  setCurrentRadioDictAction,
  setDataSourceAction,
  setIsTableLoadingAction,
  setPaginationAction,
  setSearchParamAction,
} from './reducer'

// 跳转订单详情
export const jumpApplicationDetail = (record: any) => {
  history.replace({
    pathname: `${SUPROUTE}/invoiceApplicationDetail`,
    state: {
      orderId: record.id,
      applicationNumber: record.invoiceApplicationNumber,
    },
  })
}

const useInvoiceApplicationHook = () => {
  const [state, dispatch] = useReducer(reducer, initialState)
  const { checkedRadioKey, currentRadioDict, pagination, searchParam } = state
  const dispatchredux = useDispatch()
  const { pagekey } = useTypedSelector((state) => state.pageCache)
  const CACHE_KEY = history.location.pathname

  const handleCheckedChange = (key: invoiceTabKey) => {
    dispatch(setCheckedRadioKeyAction(key))
    handleOrderListRequest({
      invoicingState: currentRadioDict[key]?.keyName,
      pageNo: 1,
      pageSize: pagination.pagesize,
    })
  }

  const handleSearchClick = (value: any) => {
    dispatch(setSearchParamAction(value))
    handleOrderListRequest(
      {
        ...value,
        pageNo: 1,
        pageSize: pagination.pagesize,
      },
      true,
    )
  }

  const handlePaginationChange = (page: number, pageSize?: number) => {
    handleOrderListRequest({
      pageNo: page,
      pageSize: pageSize ? pageSize : pagination.pagesize,
    })
    dispatch(
      setPaginationAction({
        ...pagination,
        pagesize: pageSize ? pageSize : pagination.pagesize,
        current: page,
      }),
    )
  }

  const handleOrderListRequest = async (
    param: OrderInvoicingParams,
    isSearch?: boolean,
  ) => {
    const searchParams = isSearch ? {} : { ...searchParam }
    getInvoiceCount()
    dispatch(setIsTableLoadingAction(true))
    const res = await GET_ORDER_INVOICING_PAGE({
      ...searchParams,
      ...param,
      invoicingState:
        param.invoicingState !== undefined
          ? param.invoicingState
          : currentRadioDict[checkedRadioKey]?.keyName,
    })
    if (isResponseCodeSuccess(res.code)) {
      const resData = res.data
      // 设置当前表格数据
      dispatch(setDataSourceAction(resData.content))
      // 设置当前页面数据量
      dispatch(
        setPaginationAction({
          pagesize: resData.pageSize,
          current: resData.pageNo,
          total: resData.totalCount,
        }),
      )
      dispatch(setIsTableLoadingAction(false))
    }
  }

  const handleTableRefresh = async () => {
    handleOrderListRequest({
      pageNo: 1,
      pageSize: pagination.pagesize,
    })
    dispatch(
      setPaginationAction({
        ...pagination,
        current: 1,
      }),
    )
  }

  useEffect(() => {
    const flag = getpagecache()
    if (flag) {
      const action = reloadStateAction(flag)
      dispatch(action)
    } else {
      handleOrderListRequest({
        pageSize: pagination.pagesize,
        pageNo: pagination.current,
      })
    }
    // eslint-disable-next-line
  }, [])

  useSkipInitEffect(() => {
    // 缓存存数据
    const action = setModuleDataAction({
      key: CACHE_KEY,
      data: state,
    })
    dispatchredux(action)
    // eslint-disable-next-line
  }, [state])

  // 获取数据
  const getpagecache = () => {
    const data = pagekey.filter((item) => item.key === CACHE_KEY)
    if (data.length === 1) {
      return data[0].data
    }
    return null
  }

  // 获取供应商订单待履约、履约中的数量
  const getInvoiceCount = async () => {
    const res = await GET_INVOICE_COUNT({
      type: '3',
    })
    if (isResponseCodeSuccess(res.code)) {
      const resData = res.data
      const newRadioDict = { ...currentRadioDict }
      newRadioDict['开票中']!.value = `开票中(${countToStr(resData)})`
      dispatch(setCurrentRadioDictAction(newRadioDict))
    }
  }

  // 下载附件
  const onDownload = (record: any) => {
    POST_DOWNLOAD_INVOICE_ZIP({
      orderId: record.id,
    })
  }

  return {
    hookstate: state,
    handleCheckedChange,
    handlePaginationChange,
    handleSearchClick,
    handleTableRefresh,
    onDownload,
  }
}
export default useInvoiceApplicationHook
import { useEffect, useReducer } from 'react'
import { history, useTypedSelector } from '../../redux/store'
import { countToStr, isResponseCodeSuccess } from '../../tools/util'
import {
  OrderInvoicingParams,
  GET_ORDER_INVOICING_PAGE,
  POST_DOWNLOAD_INVOICE_ZIP,
  GET_INVOICE_COUNT,
} from '../../api/orderManage'
import { useSkipInitEffect } from '../../tools/utilHooks'
import { setModuleDataAction } from '../../modules/pagecache'
import { useDispatch } from 'react-redux'
import { SUPROUTE } from '../../route'
import reducer, {
  initialState,
  invoiceTabKey,
  reloadStateAction,
  setCheckedRadioKeyAction,
  setCurrentRadioDictAction,
  setDataSourceAction,
  setIsTableLoadingAction,
  setPaginationAction,
  setSearchParamAction,
} from './reducer'

// 跳转订单详情
export const jumpApplicationDetail = (record: any) => {
  history.replace({
    pathname: `${SUPROUTE}/invoiceApplicationDetail`,
    state: {
      orderId: record.id,
      applicationNumber: record.invoiceApplicationNumber,
    },
  })
}

const useInvoiceApplicationHook = () => {
  const [state, dispatch] = useReducer(reducer, initialState)
  const { checkedRadioKey, currentRadioDict, pagination, searchParam } = state
  const dispatchredux = useDispatch()
  const { pagekey } = useTypedSelector((state) => state.pageCache)
  const CACHE_KEY = history.location.pathname

  const handleCheckedChange = (key: invoiceTabKey) => {
    dispatch(setCheckedRadioKeyAction(key))
    handleOrderListRequest({
      invoicingState: currentRadioDict[key]?.keyName,
      pageNo: 1,
      pageSize: pagination.pagesize,
    })
  }

  const handleSearchClick = (value: any) => {
    dispatch(setSearchParamAction(value))
    handleOrderListRequest(
      {
        ...value,
        pageNo: 1,
        pageSize: pagination.pagesize,
      },
      true,
    )
  }

  const handlePaginationChange = (page: number, pageSize?: number) => {
    handleOrderListRequest({
      pageNo: page,
      pageSize: pageSize ? pageSize : pagination.pagesize,
    })
    dispatch(
      setPaginationAction({
        ...pagination,
        pagesize: pageSize ? pageSize : pagination.pagesize,
        current: page,
      }),
    )
  }

  const handleOrderListRequest = async (
    param: OrderInvoicingParams,
    isSearch?: boolean,
  ) => {
    const searchParams = isSearch ? {} : { ...searchParam }
    getInvoiceCount()
    dispatch(setIsTableLoadingAction(true))
    const res = await GET_ORDER_INVOICING_PAGE({
      ...searchParams,
      ...param,
      invoicingState:
        param.invoicingState !== undefined
          ? param.invoicingState
          : currentRadioDict[checkedRadioKey]?.keyName,
    })
    if (isResponseCodeSuccess(res.code)) {
      const resData = res.data
      // 设置当前表格数据
      dispatch(setDataSourceAction(resData.content))
      // 设置当前页面数据量
      dispatch(
        setPaginationAction({
          pagesize: resData.pageSize,
          current: resData.pageNo,
          total: resData.totalCount,
        }),
      )
      dispatch(setIsTableLoadingAction(false))
    }
  }

  const handleTableRefresh = async () => {
    handleOrderListRequest({
      pageNo: 1,
      pageSize: pagination.pagesize,
    })
    dispatch(
      setPaginationAction({
        ...pagination,
        current: 1,
      }),
    )
  }

  useEffect(() => {
    const flag = getpagecache()
    if (flag) {
      const action = reloadStateAction(flag)
      dispatch(action)
    } else {
      handleOrderListRequest({
        pageSize: pagination.pagesize,
        pageNo: pagination.current,
      })
    }
    // eslint-disable-next-line
  }, [])

  useSkipInitEffect(() => {
    // 缓存存数据
    const action = setModuleDataAction({
      key: CACHE_KEY,
      data: state,
    })
    dispatchredux(action)
    // eslint-disable-next-line
  }, [state])

  // 获取数据
  const getpagecache = () => {
    const data = pagekey.filter((item) => item.key === CACHE_KEY)
    if (data.length === 1) {
      return data[0].data
    }
    return null
  }

  // 获取供应商订单待履约、履约中的数量
  const getInvoiceCount = async () => {
    const res = await GET_INVOICE_COUNT({
      type: '3',
    })
    if (isResponseCodeSuccess(res.code)) {
      const resData = res.data
      const newRadioDict = { ...currentRadioDict }
      newRadioDict['开票中']!.value = `开票中(${countToStr(resData)})`
      dispatch(setCurrentRadioDictAction(newRadioDict))
    }
  }

  // 下载附件
  const onDownload = (record: any) => {
    POST_DOWNLOAD_INVOICE_ZIP({
      orderId: record.id,
    })
  }

  return {
    hookstate: state,
    handleCheckedChange,
    handlePaginationChange,
    handleSearchClick,
    handleTableRefresh,
    onDownload,
  }
}
export default useInvoiceApplicationHook
